import Vue from 'vue';

import apiFactory from '@/api/default';
const API = apiFactory('intrinsics');

const state = {
  intrinsicsSearchResults: [],
  currentIntrinsic: {},
};

const getters = {
  intrinsicsSearchResults: (state) => state.intrinsicsSearchResults,
  currentIntrinsic: (state) => state.currentIntrinsic,
};

const mutations = {
  setIntrinsicsSearchResults: (state, intrinsicsSearchResults) => {
    // First strip them of their _id
    for (const i of intrinsicsSearchResults) {
      delete i._id;
    }
    state.intrinsicsSearchResults = intrinsicsSearchResults;
  },
  updateIntrinsicsSearchResults: (state, task) => {
    const index = state.intrinsicsSearchResults.findIndex((el)=>el._id === task._id);
    if (index >= 0) Vue.set(state.intrinsicsSearchResults, index, task);
  },
  removeFromIntrinsicsSearchResults: (state, id)=>{
    state.intrinsicsSearchResults.data = state.intrinsicsSearchResults.filter((obj)=>{
      return obj._id !== id;
    });
    state.intrinsicsSearchResults.total--;
  },
  setCurrentIntrinsic: (state, currentIntrinsic) => {
    state.currentIntrinsic = currentIntrinsic;
  },
};

const actions = {
  async searchIntrinsics({commit}, query) {
    const response = await API.search(query);
    commit('setIntrinsicsSearchResults', response.data);
    return response.data;
  },
  async loadIntrinsic({commit}, data) {
    const response = await API.load(data.id, data.query);
    commit('setCurrentIntrinsic', response.data);
    return response.data;
  },
  async createIntrinsic({commit}, data) {
    const response = await API.create(data);
    return response.data;
  },
  async updateIntrinsic({commit}, payload) {
    const response = await API.update(payload.id, payload.data);
    commit('updateIntrinsicsSearchResults', response.data);
    return response.data;
  },
  async deleteIntrinsic({commit}, id) {
    const response = await API.remove(id);
    commit('removeFromIntrinsicsSearchResults', id);
    return response;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
